// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;They search out wickedness and lay a cunning trap,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;for deep are the inward thoughts of the heart.<br> </p> </div></div>";
// Exports
module.exports = code;